function checkSectionVisibility(targetElement, isWithinClass) {
    const section = document.querySelector('#shopify-section-product-template');
    if (!section) return;

    const sectionTop = section.getBoundingClientRect().top;
    const sectionBottom = section.getBoundingClientRect().bottom; 
    const windowHeight = window.innerHeight;

    if (sectionTop <= 0 && sectionBottom >= 0) {
        if (!isWithinClass) {
            targetElement.classList.remove('fixed-bottom__button--fade-out');
            targetElement.classList.add('fixed-bottom__button--fade-in');
            return true;
        }
    } else if (sectionBottom <= windowHeight) {
        if (isWithinClass) {
            targetElement.classList.remove('fixed-bottom__button--fade-in');
            targetElement.classList.add('fixed-bottom__button--fade-out');
            return false;
        }
    }
    return isWithinClass;
}

function addButtonFix(className = "") {
    let isScrolling = false;
    let isWithinClass = false;
    const targetElement = document.querySelector(className);
    if (!targetElement) return;
    window.addEventListener('scroll', function() {
        if (!isScrolling) {
            window.requestAnimationFrame(function() {
                if (targetElement) {
                    targetElement.classList.add('fixed-bottom__button');
                }
                isWithinClass = checkSectionVisibility(targetElement, isWithinClass);
                isScrolling = false;
            });
            isScrolling = true;
        }
    });
}
